import withQuizName from 'src/utils/hocs/with-quiz-name/with-quiz-name';

import AngerIcon from '../assets/images/quiz/emotions-anger.svg';
import AnxietyIcon from '../assets/images/quiz/emotions-anxiety.svg';
import FearIcon from '../assets/images/quiz/emotions-fear.svg';
import SadnessIcon from '../assets/images/quiz/emotions-sadness.svg';
import ComplicatedIcon from '../assets/images/quiz/status-icon-complicated.svg';
import DivorcedIcon from '../assets/images/quiz/status-icon-divorced.svg';
import RelationshipIcon from '../assets/images/quiz/status-icon-in-relationship.svg';
import SingleIcon from '../assets/images/quiz/status-icon-single.svg';
import { QuizStep, QuizStepType, Step } from './quiz';

export const STEPS: { [key in QuizStep]: Step } = {
  [QuizStep.WELCOME]: {
    type: QuizStepType.OTHER,
    step: QuizStep.WELCOME,
    section: 'Introduction',
    title: '',
  },
  [QuizStep.WELCOME_AB_TEST]: {
    type: QuizStepType.OTHER,
    step: QuizStep.WELCOME_AB_TEST,
    section: 'Introduction',
    title: '',
  },
  [QuizStep.WELCOME_FOUR_VARIANTS_AB_TEST]: {
    type: QuizStepType.OTHER,
    step: QuizStep.WELCOME_FOUR_VARIANTS_AB_TEST,
    section: 'Introduction',
    title: '',
  },
  [QuizStep.WELCOME_THREE_VARIANTS_AB_TEST]: {
    type: QuizStepType.OTHER,
    step: QuizStep.WELCOME_THREE_VARIANTS_AB_TEST,
    section: 'Introduction',
    title: '',
  },
  [QuizStep.INTRO]: {
    type: QuizStepType.OTHER,
    step: QuizStep.INTRO,
    section: 'Introduction',
    title: '',
  },
  [QuizStep.FACING_REPEATING]: {
    type: QuizStepType.SINGLE_OPTION_SELECT,
    step: QuizStep.FACING_REPEATING,
    section: 'Introduction',
    title: 'Are you facing repeating patterns in life?',
    nextButtonText: 'Next',
    options: [
      {
        value: 0,
        label: 'Yes',
      },
      {
        value: 1,
        label: 'No',
      },
      {
        value: 2,
        label: 'Not sure',
      },
    ],
  },
  [QuizStep.ASPECT]: {
    type: QuizStepType.SINGLE_OPTION_SELECT,
    step: QuizStep.ASPECT,
    section: 'Introduction',
    title: 'Which aspect of a relationship attracts you?',
    nextButtonText: 'Next',
    options: [
      {
        value: 0,
        label: 'Affection',
      },
      {
        value: 1,
        label: 'Emotional intimacy',
      },
      {
        value: 2,
        label: 'Communication',
      },
      {
        value: 3,
        label: 'Social',
      },
    ],
  },
  [QuizStep.DESIRED_RELATIONSHIP]: {
    type: QuizStepType.SINGLE_OPTION_SELECT,
    step: QuizStep.DESIRED_RELATIONSHIP,
    section: 'Introduction',
    title: "What's your desired relationship type?",
    nextButtonText: 'Next',
    options: [
      {
        value: 0,
        label: 'Dating',
      },
      {
        value: 1,
        label: 'Committed relationship',
      },
      {
        value: 2,
        label: 'Marriage',
      },
      {
        value: 3,
        label: 'Casual sex',
      },
    ],
  },
  [QuizStep.PREVIOUS_RELATIONSHIP]: {
    type: QuizStepType.SINGLE_OPTION_SELECT,
    step: QuizStep.PREVIOUS_RELATIONSHIP,
    section: 'Introduction',
    title: 'What describes your previous relationship?',
    nextButtonText: 'Next',
    options: [
      {
        value: 0,
        label: 'It was passionate',
      },
      {
        value: 1,
        label: 'I found a twin soul',
      },
      {
        value: 2,
        label: 'We had commitment',
      },
      {
        value: 4,
        label: 'None of above',
      },
    ],
  },
  [QuizStep.TOXIC_RELATIONSHIP]: {
    type: QuizStepType.SINGLE_OPTION_SELECT,
    step: QuizStep.TOXIC_RELATIONSHIP,
    section: 'Introduction',
    title: 'Which toxic relationship aspects have you faced?',
    nextButtonText: 'Find out',
    options: [
      {
        value: 0,
        label: 'Disrespect',
      },
      {
        value: 1,
        label: 'Controlling behavior',
      },
      {
        value: 2,
        label: 'Lack of support',
      },
      {
        value: 4,
        label: 'None of above',
      },
    ],
  },
  [QuizStep.IN_LOVE]: {
    type: QuizStepType.SINGLE_OPTION_SELECT,
    step: QuizStep.IN_LOVE,
    section: 'Introduction',
    title: 'Would you say that you’re in love right now?',
    nextButtonText: 'Next',
    options: [
      {
        value: 0,
        label: 'Yes, it’s mutual',
      },
      {
        value: 1,
        label: "Yes, but it's not mutual",
      },
      {
        value: 2,
        label: 'No, not now',
      },
    ],
  },
  [QuizStep.ROMANTIC_FEELINGS]: {
    type: QuizStepType.SINGLE_OPTION_SELECT,
    step: QuizStep.ROMANTIC_FEELINGS,
    section: 'Introduction',
    title: 'Do you want to navigate your romantic feelings?',
    nextButtonText: 'Next',
    options: [
      {
        value: 0,
        label: 'Yes, I want to explore them',
      },
      {
        value: 1,
        label: 'Yes, I want to create a stronger bond with my partner',
      },
      {
        value: 2,
        label: 'No, I want to know myself better',
      },
      {
        value: 3,
        label: 'No, I want to change my relationship patterns',
      },
    ],
  },
  [QuizStep.KARMIC_LESSONS]: {
    type: QuizStepType.SINGLE_OPTION_SELECT,
    step: QuizStep.KARMIC_LESSONS,
    section: 'Introduction',
    title: 'Do you want to know your karmic lessons?',
    nextButtonText: 'Next',
    options: [
      {
        value: 0,
        label: 'Yes, totally',
      },
      {
        value: 1,
        label: 'No, I want to rethink my experience',
      },
    ],
  },

  [QuizStep.DISCOVER_SLIDER]: {
    type: QuizStepType.OTHER,
    step: QuizStep.DISCOVER_SLIDER,
    section: 'Introduction',
    title: '',
  },
  [QuizStep.PURPOSE]: {
    type: QuizStepType.SINGLE_OPTION_SELECT,
    step: QuizStep.PURPOSE,
    section: 'Life purpose',
    title: 'How would you identify your life’s purpose?',
    options: [
      {
        value: 0,
        label: 'Work & Career',
      },
      {
        value: 1,
        label: 'Wealth & Money',
      },
      {
        value: 2,
        label: 'Love & Relationships',
      },
      {
        value: 3,
        label: 'Spirituality & Wellness',
      },
    ],
  },
  [QuizStep.JOB_LOVING]: {
    type: QuizStepType.SINGLE_OPTION_SELECT,
    step: QuizStep.JOB_LOVING,
    section: 'Life purpose',
    title: (
      <>
        Are you happy with <br />
        your job?
      </>
    ),
    options: [
      {
        value: 0,
        label: 'I do something I love',
      },
      {
        value: 1,
        label: 'I’m struggling with it',
      },
      {
        value: 2,
        label: 'I hate my job',
      },
      {
        value: 3,
        label: 'I’m not working',
      },
    ],
  },
  [QuizStep.FINANCIAL_GOAL]: {
    type: QuizStepType.SINGLE_OPTION_SELECT,
    step: QuizStep.FINANCIAL_GOAL,
    section: 'Life purpose',
    title: (
      <>
        Do you have a financial
        <br />
        goal?
      </>
    ),
    options: [
      {
        value: 0,
        label: 'A raise would be welcomed',
      },
      {
        value: 1,
        label: 'Accumulate enough savings',
      },
      {
        value: 2,
        label: 'Financial independence',
      },
      {
        value: 3,
        label: 'Double my income',
      },
    ],
  },
  [QuizStep.LIFE_ASPECTS]: {
    type: QuizStepType.SINGLE_OPTION_SELECT,
    step: QuizStep.LIFE_ASPECTS,
    section: 'Life purpose',
    title: "What life aspects you'd like to add to your profile?",
    options: [
      {
        value: 0,
        label: 'Mood & Health',
      },
      {
        value: 1,
        label: 'Money',
      },
      {
        value: 2,
        label: 'Sexual life',
      },
      {
        value: 3,
        label: 'Relationships',
      },
    ],
  },
  [QuizStep.WORK_OUT]: {
    type: QuizStepType.SINGLE_OPTION_SELECT,
    step: QuizStep.WORK_OUT,
    section: 'Life purpose',
    title: "What are the issues that you'd like to work out?",
    options: [
      {
        value: 0,
        label: 'How the Moon affects my energy',
      },
      {
        value: 1,
        label: 'How the Moon affects my decisions',
      },
      {
        value: 2,
        label: 'How the Moon affects my compatibility',
      },
      {
        value: 3,
        label: 'How the Moon affects my destiny',
      },
    ],
  },
  [QuizStep.SPIRITUAL_GOAL]: {
    type: QuizStepType.SINGLE_OPTION_SELECT,
    step: QuizStep.SPIRITUAL_GOAL,
    section: 'Life purpose',
    title: 'Do you want to define your life’s spiritual goal?',
    options: [
      {
        value: 0,
        label: 'Yes, I want to understand myself better',
      },
      {
        value: 1,
        label: 'No, I just want to know how Moon affects me',
      },
      {
        value: 2,
        label: 'Not really, I’m more interested in breaking the karmic cycle',
      },
    ],
  },
  [QuizStep.WE_GOT_YOU]: {
    type: QuizStepType.OTHER,
    step: QuizStep.WE_GOT_YOU,
    section: 'Life purpose',
    title: '',
  },

  [QuizStep.MOOD]: {
    type: QuizStepType.SINGLE_OPTION_SELECT,
    step: QuizStep.MOOD,
    section: 'Mood & Emotions',
    title: 'Tell us, how are you feeling today?',
    options: [
      {
        value: 0,
        label: 'Marvelous',
      },
      {
        value: 1,
        label: 'Just fine',
      },
      {
        value: 2,
        label: 'So-so',
      },
      {
        value: 3,
        label: 'Awful',
      },
    ],
  },
  [QuizStep.LIFE]: {
    type: QuizStepType.SINGLE_OPTION_SELECT,
    step: QuizStep.LIFE,
    section: 'Mood & Emotions',
    title: 'How would you describe your life right now?',
    options: [
      {
        value: 0,
        label: 'Life is beautiful',
      },
      {
        value: 1,
        label: 'Going well, I think',
      },
      {
        value: 2,
        label: 'Worse than expected',
      },
      {
        value: 3,
        label: 'It’s a disaster',
      },
    ],
  },
  [QuizStep.EMOTIONS]: {
    type: QuizStepType.SINGLE_OPTION_SELECT,
    step: QuizStep.EMOTIONS,
    section: 'Mood & Emotions',
    title: 'Have you experienced any of these emotions lately?',
    options: [
      {
        value: 0,
        label: 'Anxiety',
        image: AnxietyIcon,
      },
      {
        value: 1,
        label: 'Fear',
        image: FearIcon,
      },
      {
        value: 2,
        label: 'Anger',
        image: AngerIcon,
      },
      {
        value: 3,
        label: 'Sadness',
        image: SadnessIcon,
      },
    ],
    skipOption: { value: 4, label: "I'm fine" },
  },
  [QuizStep.CRITICS_SENSITIVE]: {
    type: QuizStepType.SINGLE_OPTION_SELECT,
    step: QuizStep.CRITICS_SENSITIVE,
    section: 'Mood & Emotions',
    title: 'Are you sensitive to disapproval?',
    options: [
      {
        value: 0,
        label: 'Never ever',
      },
      {
        value: 1,
        label: 'Occasionally',
      },
      {
        value: 2,
        label: 'Sometimes',
      },
      {
        value: 3,
        label: 'Definitely',
      },
    ],
  },
  [QuizStep.HOT_TEMPRED]: {
    type: QuizStepType.SINGLE_OPTION_SELECT,
    step: QuizStep.HOT_TEMPRED,
    section: 'Mood & Emotions',
    title: (
      <>
        Are you a hot-tempered <br />
        person?
      </>
    ),
    options: [
      {
        value: 0,
        label: 'Yes',
      },
      {
        value: 1,
        label: 'Not really',
      },
      {
        value: 2,
        label: 'No',
      },
    ],
  },
  [QuizStep.MOOD_SWINGS]: {
    type: QuizStepType.SINGLE_OPTION_SELECT,
    step: QuizStep.MOOD_SWINGS,
    section: 'Mood & Emotions',
    title: 'Do you experience mood swings often?',
    options: [
      {
        value: 0,
        label: 'Yes',
      },
      {
        value: 1,
        label: 'Not really',
      },
      {
        value: 2,
        label: 'No',
      },
    ],
  },

  [QuizStep.TAKE_COMMAND]: {
    type: QuizStepType.OTHER,
    step: QuizStep.TAKE_COMMAND,
    section: 'Mood & Emotions',
    title: '',
  },

  [QuizStep.GENDER]: {
    type: QuizStepType.SINGLE_OPTION_SELECT,
    step: QuizStep.GENDER,
    section: 'Personalization',
    title: 'Which gender were you born with?',
    options: [
      {
        value: 0,
        label: 'Female',
      },
      {
        value: 1,
        label: 'Male',
      },
      {
        value: 2,
        label: 'Other',
      },
    ],
  },
  [QuizStep.NAME]: {
    type: QuizStepType.OTHER,
    step: QuizStep.NAME,
    section: 'Personalization',
    title: <>What’s your name?</>,
  },
  [QuizStep.GREETINGS]: {
    type: QuizStepType.TEXT_CARD_WITH_BACKGROUND_IMAGE,
    step: QuizStep.GREETINGS,
    section: 'Personalization',
    title: '',
    TitleComponent: withQuizName(({ name }) =>
      name === '' ? <>Hello, there!</> : <>Hello, {name}!</>,
    ),
    TextContentComponent: (
      <p style={{ color: '#a6a1c5' }}>
        We&apos;d like to ask you a few questions to create your personal report
      </p>
    ),
    nextButtonText: 'Get started',
  },
  [QuizStep.DATE_OF_BIRTH]: {
    type: QuizStepType.OTHER,
    step: QuizStep.DATE_OF_BIRTH,
    section: 'Personalization',
    title: 'What’s your date of birth?',
    subtitle: 'Please provide the most accurate info',
  },
  [QuizStep.HOMETOWN]: {
    type: QuizStepType.OTHER,
    step: QuizStep.HOMETOWN,
    section: 'Personalization',
    title: 'Where were you born?',
    subtitle: 'We will use this info to create your report',
  },
  [QuizStep.BIRTH_TIME_KNOWLEDGE]: {
    type: QuizStepType.SINGLE_OPTION_SELECT,
    step: QuizStep.BIRTH_TIME_KNOWLEDGE,
    section: 'Personalization',
    title: (
      <>
        Do you know your <br />
        birth time?
      </>
    ),
    options: [
      {
        value: 0,
        label: 'Yes',
      },
      {
        value: 1,
        label: 'No',
      },
    ],
  },
  [QuizStep.NO_PROBLEM]: {
    type: QuizStepType.TEXT_CARD_WITH_BACKGROUND_IMAGE,
    step: QuizStep.NO_PROBLEM,
    section: 'Personalization',
    title: 'No problem!',
    TextContentComponent: (
      <p>
        You can still find plenty of great insights without knowing your birth
        time. You can add these info lately.
      </p>
    ),
  },
  [QuizStep.BIRTH_TIME]: {
    type: QuizStepType.OTHER,
    step: QuizStep.BIRTH_TIME,
    section: 'Personalization',
    title: 'What’s your time of birth?',
    subtitle: 'Try to be as accurate as possible',
  },
  [QuizStep.SIGN_HELPED]: {
    type: QuizStepType.OTHER,
    step: QuizStep.SIGN_HELPED,
    section: 'Personalization',
    title: '',
  },
  [QuizStep.RELATIONSHIP]: {
    type: QuizStepType.SINGLE_OPTION_SELECT,
    step: QuizStep.RELATIONSHIP,
    section: 'Relationship status',
    title: 'What’s your relationship status?',
    options: [
      {
        value: 0,
        label: 'Single',
        image: SingleIcon,
      },
      {
        value: 1,
        label: 'In relationships',
        image: RelationshipIcon,
      },
      {
        value: 2,
        label: 'Divorced',
        image: DivorcedIcon,
      },
      {
        value: 3,
        label: 'It’s complicated',
        image: ComplicatedIcon,
      },
    ],
    skipOption: { value: 4, label: 'Skip this step' },
  },
  [QuizStep.SEX]: {
    type: QuizStepType.SINGLE_OPTION_SELECT,
    step: QuizStep.SEX,
    section: 'Relationship status',
    title: 'Is sex your priority when you have a relationship?',
    options: [
      {
        value: 0,
        label: 'Yes',
      },
      {
        value: 1,
        label: 'No',
      },
      {
        value: 2,
        label: 'Not sure',
      },
    ],
  },
  [QuizStep.COMFORTABLE]: {
    type: QuizStepType.SINGLE_OPTION_SELECT,
    step: QuizStep.COMFORTABLE,
    section: 'Relationship status',
    title: 'Are you comfortable around unfamiliar people?',
    options: [
      {
        value: 0,
        label: 'Yes',
      },
      {
        value: 1,
        label: 'No',
      },
      {
        value: 2,
        label: 'It depends',
      },
    ],
  },
  [QuizStep.GOOD_ENOUGH]: {
    type: QuizStepType.SINGLE_OPTION_SELECT,
    step: QuizStep.GOOD_ENOUGH,
    section: 'Relationship status',
    title: 'Do you often worry that you are not good enough?',
    options: [
      {
        value: 0,
        label: 'Yes',
      },
      {
        value: 1,
        label: 'No',
      },
      {
        value: 2,
        label: 'Sometimes',
      },
    ],
  },
  [QuizStep.RELATIONSHIP_GOAL]: {
    type: QuizStepType.SINGLE_OPTION_SELECT,
    step: QuizStep.RELATIONSHIP_GOAL,
    section: 'Relationship status',
    title: 'How do you feel about your relationship goals?',
    options: [
      {
        value: 0,
        label: 'Quite optimistic',
      },
      {
        value: 1,
        label: 'Somewhat cautious',
      },
      {
        value: 2,
        label: 'A little anxious',
      },
      {
        value: 3,
        label: 'Rather pessimistic',
      },
    ],
  },
  [QuizStep.LONG_TERM]: {
    type: QuizStepType.SINGLE_OPTION_SELECT,
    step: QuizStep.LONG_TERM,
    section: 'Relationship status',
    title: 'Are you looking for a long-term relationship?',
    options: [
      {
        value: 0,
        label: 'Yes',
      },
      {
        value: 1,
        label: 'Not really',
      },
      {
        value: 2,
        label: 'No, I want to rethink my experience',
      },
    ],
  },
  [QuizStep.PARTNER_ASTROLOGY_SIGN]: {
    type: QuizStepType.OTHER,
    step: QuizStep.PARTNER_ASTROLOGY_SIGN,
    section: 'Relationship status',
    title: 'What’s your partner’s date of birth?',
    subtitle: 'We need it to create your compatibility report',
  },
  [QuizStep.PARTNER_BIRTH_TIME_KNOWLEDGE]: {
    type: QuizStepType.SINGLE_OPTION_SELECT,
    step: QuizStep.PARTNER_BIRTH_TIME_KNOWLEDGE,
    section: 'Relationship status',
    title: 'Do you know what time your partner was born?',
    options: [
      {
        value: 0,
        label: 'Yes',
      },
      {
        value: 1,
        label: 'No',
      },
    ],
  },
  [QuizStep.PARTNER_NO_PROBLEM]: {
    type: QuizStepType.TEXT_CARD_WITH_BACKGROUND_IMAGE,
    step: QuizStep.PARTNER_NO_PROBLEM,
    section: 'Relationship status',
    title: 'No problem!',
    TextContentComponent: (
      <p>
        We will create your compatibility report anyway. You can always add this
        info to your profile to regenerate the report!
      </p>
    ),
  },
  [QuizStep.PARTNER_BIRTH_TIME]: {
    type: QuizStepType.OTHER,
    step: QuizStep.PARTNER_BIRTH_TIME,
    section: 'Relationship status',
    title: 'What’s your partner’s time of birth?',
    subtitle: 'We need it to create your compatibility report',
  },
  [QuizStep.PARTNER_HOMETOWN]: {
    type: QuizStepType.OTHER,
    step: QuizStep.PARTNER_HOMETOWN,
    section: 'Relationship status',
    title: 'What city was your partner born in?',
    subtitle: 'We need it to create your compatibility report',
  },
  [QuizStep.DISCUSSING_PROBLEMS]: {
    type: QuizStepType.SINGLE_OPTION_SELECT,
    step: QuizStep.DISCUSSING_PROBLEMS,
    section: 'Relationship status',
    title: 'Are you discussing all the problems together?',
    options: [
      {
        value: 0,
        label: 'Yes',
      },
      {
        value: 1,
        label: 'No',
      },
      {
        value: 2,
        label: 'It depends',
      },
    ],
  },
  [QuizStep.SEX_RELATIONSHIP]: {
    type: QuizStepType.SINGLE_OPTION_SELECT,
    step: QuizStep.SEX_RELATIONSHIP,
    section: 'Relationship status',
    title: 'Is sex your priority in your relationship?',
    options: [
      {
        value: 0,
        label: 'Yes',
      },
      {
        value: 1,
        label: 'No',
      },
      {
        value: 2,
        label: 'Not sure',
      },
    ],
  },

  [QuizStep.AFFECT_RELATIONSHIP]: {
    type: QuizStepType.SINGLE_OPTION_SELECT,
    step: QuizStep.AFFECT_RELATIONSHIP,
    section: 'Relationship status',
    title: 'Are any of these factors affect your relationship?',
    options: [
      {
        value: 0,
        label: 'Infidelity',
      },
      {
        value: 1,
        label: 'Divorce is on the table',
      },
      {
        value: 2,
        label: 'General misunderstanding',
      },
      {
        value: 3,
        label: 'Anxiety',
      },
    ],
    skipOption: { value: 4, label: 'None of these' },
  },

  [QuizStep.FINAL_SUMMARY]: {
    type: QuizStepType.OTHER,
    step: QuizStep.FINAL_SUMMARY,
    section: 'Relationship status',
    title: '',
  },
  [QuizStep.ENTER_EMAIL]: {
    type: QuizStepType.OTHER,
    step: QuizStep.ENTER_EMAIL,
    section: 'Relationship status',
    title: (
      <>
        Enter your email to get your <em>detailed report</em>
      </>
    ),
  },

  [QuizStep.BEST_MATCHES]: {
    type: QuizStepType.OTHER,
    step: QuizStep.BEST_MATCHES,
    section: 'Relationship status',
    title: 'Find your perfect matches',
    subtitle: 'Switch between signs to find your perfect partner',
  },
  [QuizStep.PARTNER_COMPATIBILITY]: {
    type: QuizStepType.OTHER,
    step: QuizStep.PARTNER_COMPATIBILITY,
    section: 'Relationship status',
    title: 'Your compatibility report is ready',
    subtitle: 'Discover the strengths and weaknesses in your relationship',
  },
  [QuizStep.ANIMATION_SCREENS]: {
    type: QuizStepType.OTHER,
    step: QuizStep.ANIMATION_SCREENS,
    section: 'Relationship status',
    title: '',
  },
  [QuizStep.PERSONAL_PLAN_HIGHLIGHTS]: {
    type: QuizStepType.OTHER,
    step: QuizStep.PERSONAL_PLAN_HIGHLIGHTS,
    section: 'Relationship status',
    title: '',
  },
};

export const QUIZ_STEPS_INTRODUCTION = [
  QuizStep.WELCOME,
  QuizStep.WELCOME_AB_TEST,
  QuizStep.WELCOME_FOUR_VARIANTS_AB_TEST,
  QuizStep.WELCOME_THREE_VARIANTS_AB_TEST,
  QuizStep.FACING_REPEATING,
  QuizStep.ASPECT,
  QuizStep.DESIRED_RELATIONSHIP,
  QuizStep.PREVIOUS_RELATIONSHIP,
  QuizStep.TOXIC_RELATIONSHIP,
  QuizStep.INTRO,
  QuizStep.IN_LOVE,
  QuizStep.ROMANTIC_FEELINGS,
  QuizStep.KARMIC_LESSONS,
  QuizStep.DISCOVER_SLIDER,
];
export const QUIZ_STEPS_PURPOSE = [
  QuizStep.PURPOSE,
  QuizStep.JOB_LOVING,
  QuizStep.FINANCIAL_GOAL,
  QuizStep.LIFE_ASPECTS,
  QuizStep.WORK_OUT,
  QuizStep.SPIRITUAL_GOAL,
  QuizStep.WE_GOT_YOU,
];
export const QUIZ_STEPS_MOOD = [
  QuizStep.LIFE,
  QuizStep.MOOD,
  QuizStep.EMOTIONS,
  QuizStep.CRITICS_SENSITIVE,
  QuizStep.HOT_TEMPRED,
  QuizStep.MOOD_SWINGS,
  QuizStep.TAKE_COMMAND,
];
export const QUIZ_STEPS_PERSONALIZATION = [
  QuizStep.GENDER,
  QuizStep.NAME,
  QuizStep.GREETINGS,
  QuizStep.DATE_OF_BIRTH,
  QuizStep.HOMETOWN,
  QuizStep.BIRTH_TIME_KNOWLEDGE,
  QuizStep.NO_PROBLEM,
  QuizStep.BIRTH_TIME,
  QuizStep.SIGN_HELPED,
];

export const QUIZ_STEPS_RELATIONSHIP = [
  QuizStep.RELATIONSHIP, //SINGLE
  QuizStep.SEX, //SINGLE
  QuizStep.COMFORTABLE, //SINGLE
  QuizStep.GOOD_ENOUGH, //SINGLE
  QuizStep.RELATIONSHIP_GOAL, //SINGLE
  QuizStep.LONG_TERM, //SINGLE
  QuizStep.PARTNER_ASTROLOGY_SIGN, //IN RELATIONS
  QuizStep.PARTNER_BIRTH_TIME_KNOWLEDGE, //IN RELATIONS
  QuizStep.PARTNER_NO_PROBLEM, //IN RELATIONS
  QuizStep.PARTNER_BIRTH_TIME, //IN RELATIONS
  QuizStep.PARTNER_HOMETOWN, //IN RELATIONS
  QuizStep.DISCUSSING_PROBLEMS, //IN RELATIONS
  QuizStep.SEX_RELATIONSHIP, //IN RELATIONS
  QuizStep.AFFECT_RELATIONSHIP, //IN RELATIONS
  QuizStep.FINAL_SUMMARY, //BOTH
  QuizStep.ENTER_EMAIL, //BOTH
  QuizStep.PARTNER_COMPATIBILITY, //IN RELATIONS
  QuizStep.BEST_MATCHES, //SINGLE
  // QuizStep.ANIMATION_SCREENS, // BOTH
  // QuizStep.PERSONAL_PLAN_HIGHLIGHTS, //BOTH
];
